import { TENANTS } from './general/tenants/constants';

export const isTenant = tenant => () => process.env.REACT_APP_TENANT === tenant;

export const isAdelphi = isTenant(TENANTS.ADELPHI);

export const isBorders = isTenant(TENANTS.BORDERS);
